var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10 12.5845C12.7614 12.5845 15 10.3459 15 7.58447C15 4.82305 12.7614 2.58447 10 2.58447C7.23858 2.58447 5 4.82305 5 7.58447C5 10.3459 7.23858 12.5845 10 12.5845Z",
    fill: "#7032D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5845C12.7614 12.5845 15 10.3459 15 7.58447C15 4.82305 12.7614 2.58447 10 2.58447C7.23858 2.58447 5 4.82305 5 7.58447C5 10.3459 7.23858 12.5845 10 12.5845Z",
    stroke: "#7032D8",
    strokeWidth: 0.740741,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42188 16.9597C3.18979 15.6293 4.2944 14.5246 5.62465 13.7565C6.9549 12.9884 8.46392 12.584 10 12.584C11.5361 12.584 13.0451 12.9884 14.3753 13.7565C15.7056 14.5246 16.8102 15.6293 17.5781 16.9597",
    stroke: "#7032D8",
    strokeWidth: 0.740741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.4fcc38de4f9e48b06cc5a9a7d6485061.svg";
export { ForwardRef as ReactComponent };